import { combineReducers } from 'redux';
import { clientBulkDelete } from './ClientsBulkDelete/reducer';
import { clientsImport } from './ClientsImport/reducer';

export default combineReducers({
  clientBulkDelete,
  clientsImport,
});
